'use strict';

const { queryFirst, addClass, removeClass, hasClass, isVisible, getCookieMap, setCookie } = require('../domUtil');

const {
    MENU_OPENED,
    EVENT_KEY_ESC,
    EVENT_KEY_TAB,
    EVENT_KEY_DOWN,
    EVENT_KEY_UP,
    EVENT_KEY_LEFT,
    EVENT_KEY_RIGHT,
    EVENT_KEY_END,
    EVENT_KEY_HOME,
    EVENT_KEY_ENTER,
    EVENT_KEY_SPACE,
    KEYCODE_ENTER,
    KEYCODE_SPACE,
    KEYCODE_UP,
    KEYCODE_DOWN,
    SHOW_CLASS,
    HIDE_CLASS,
    ACTIVE_CLASS,
    ANIM_TIME_QUICK_2
} = require('../constants');
const { getJSON } = require('../util');

module.exports = function () {
    const $body = $('body');
    const bodyEl = $body[0];
    const topNav  = queryFirst('.page-top-navigation', bodyEl);

    if (!topNav) return; // no need to continue on pages with minified header

    // =========================================================================
    // Constants (scoped to init)
    // =========================================================================
    // === SELECTORS (root = ID, inner = classes). Zero deps on role/aria ===
    const SELECTORS = {
        // ---- Roots / groups (IDs) ----
        mainNav: 'nav.main-nav',
        mainMenu: '#sg-navbar-collapse',          // drawer/container
        categoryMenubar: '#category-nav',         // desktop categories UL
        mobileAccountMenubar: '#mobile-account-nav',
        headerIconsGroup: '#header-nav-icons',    //  logo +  icons header (mobile)
        headerIconsMenubar: '#icons-nav',         // icons UL

        // ---- Generic inner elements (classes) ----
        navbarToggler: '.navbar-toggler',
        navLink: '.nav-link',
        topItem: 'li.nav-item',
        dropdownContainer: '.dropdown-container',
        dropdownMenu: '.dropdown-menu',
        dropdownLink: '.dropdown-link',
        dropdownLinkVisible: '.dropdown-link:visible',
        navAssetLinkVisible: '.navasset a:visible',
        subKeyTargets: '.dropdown-menu a, .dropdown-menu button',
        navbarNav: 'ul.navbar-nav',
        headerNavLogoLink: '.header-nav-logo a',
        menuGroupNavItem: '.menu-group .nav-item',
        pageTopNav: '.page-top-navigation',
        modalBg: '.modal-background',

        // ---- Mobile L2 header strip ----
        topCategory: '.top-category',
        backInTopCategory: '.top-category .back',
        subMenuItem: '.sub-menu-wrapper > .sub-menu-item.nav-item',
        subMenuItemClosest: '.sub-menu-item.nav-item',
        subMenuItemPanel: '.sub-menu-item-panel',
        subCatName: '.sub-cat-name',
        subMenuItemExpanded: 'is-expanded',

        // ---- Header banners / promos ----
        // container & moving carousel area:
        stripeContainer: '.carousel-stripe-banner-container',
        stripeBanner: '#carousel-stripe-banner, .carousel-stripe-banner',
        // controls:
        stripePause: '.stripe-banner-pause',
        stripeNext: '.stripe-banner-next',
        stripeClose: '.close-banner',
        // visibility helpers used in code:
        evgHeroBanner: '#evg-hero-banner',
        bannerWrapperLinks: '.main-header .banner-wrapper a',
        myAccountLinkSelector: '#myaccount',
        hoverableMAlink: 'js-account-link',
        activeAccountClass: 'js-account-active'
    };

    const CLASSES = {
        show: SHOW_CLASS,
        hide: HIDE_CLASS,
        active: ACTIVE_CLASS,
        mobileOpen: 'mobile-menu-open',
        hidden: 'd-none',
        hasBanner: 'has-banner',
        hasSkinnyBanner: 'has-skinny-banner',
        in: 'in'
    };

    const MEDIA = {
        desktop: window.matchMedia('(min-width: 1200px)')
    };
    MEDIA.mobile = {
        get matches() {
            return !MEDIA.desktop.matches;
        }
    };

    const MYACCOUNT_POSTLOGIN_DESKTOP_TARGET = '#postLoginSheet';
    const MYACCOUNT_MOBILE_TARGET = '#mobileHeader';

    // === Cached handles ===
    const $document = $(document);

    const $mainNav               = $(SELECTORS.mainNav);
    const $mainMenu              = $(SELECTORS.mainMenu);
    const $categoryMenubar       = $(SELECTORS.categoryMenubar);        // Desktop/Mobile L1
    const $headerIconsMenubar    = $(SELECTORS.headerIconsMenubar);     // Desktop/Mobile UL with icons

    const $topItems              = $categoryMenubar.find(`> ${SELECTORS.topItem}`);
    const $topLinks              = $categoryMenubar.find(`> ${SELECTORS.topItem} > ${SELECTORS.navLink}`);
    const TOP_LINK_SEL           = `${SELECTORS.topItem} > ${SELECTORS.navLink}`;

    const $modalBG = $(SELECTORS.modalBg);
    const myAccountHoverSheet = queryFirst(MYACCOUNT_POSTLOGIN_DESKTOP_TARGET);
    const myAccountLink = queryFirst(SELECTORS.myAccountLinkSelector);

    const scrollBarWidth = `${window.innerWidth - bodyEl.scrollWidth}px`;
    const STORAGE_KEY = 'topnav_active_index';

    const plp = queryFirst('.plp-title');
    const categoryName = queryFirst('.category-name');

    const stripeBannerContainer = queryFirst(SELECTORS.stripeContainer);
    const stripeBanner = queryFirst(SELECTORS.stripeBanner, stripeBannerContainer);
    const stripePauseBtn = queryFirst(SELECTORS.stripePause, stripeBannerContainer);
    const stripeArrowBtn = queryFirst(SELECTORS.stripeNext, stripeBannerContainer);
    const stripeCloseBtn = queryFirst(SELECTORS.stripeClose, stripeBannerContainer);
    const headerSwiper = queryFirst('.swiper', stripeBannerContainer);

    const hoverIntentDelay = 250;
    const closeNavDelay = 200;

    let isMobileOpen = false;
    // Persist intent to keep submenus open while roving with Left/Right
    let rovingCarryOpen = false;
    // Tracks whether keyboard navigation should suppress hover behavior
    let kbdHoverLock = false;
    let restoreFocusEl = null;
    let hoverIntentTimer;
    let closeNavTimer;

    let isNavActive = false;
    let activeNavItem;

    // Tracks SR announcements
    let submenuOpen = false;
    let announcedHelpTips = false;

    let bannerManuallyPaused = false;

    /** Show or hide the global nav backdrop. */
    function modal(show = true) {
        $modalBG[show ? CLASSES.show : CLASSES.hide]();
    }

    // =========================================================================
    // PLP title → category-name sync
    // =========================================================================
    if (plp && categoryName) {
        categoryName.textContent = plp.textContent;
    }

    // =========================================================================
    // Top banner (init / pause / next / close)
    // =========================================================================
    const { hide_header_banner: headerBannerStatus } = getCookieMap();
    const bannerHidden = (headerBannerStatus === '1' || headerBannerStatus === '2');

    const BANNER_SLOT_LOAD_DEADLINE_MS = 6000;
    const HIDE_HEADER_BANNER_COOKIE_MINUTES = 24 * 60;

    function observeBannerContent() {
        if (!stripeBannerContainer) {
            // no banner on page - nothing to observe
        } else {
            let settled = false;

            const observer = new MutationObserver(() => {
                const headerSwiperInstance = headerSwiper?.swiper;
                const slidesCount = headerSwiperInstance?.slides?.length || 0;

                if (headerSwiperInstance && slidesCount > 0) {
                    settled = true;
                    observer.disconnect();
                }
            });

            observer.observe(stripeBannerContainer, { childList: true, subtree: true });

            setTimeout(() => {
                if (settled) return;

                observer.disconnect();

                const headerSwiperInstance = headerSwiper?.swiper;
                const slidesCount = headerSwiperInstance?.slides?.length || 0;

                if (!headerSwiperInstance || slidesCount === 0) {
                    stripeBannerContainer.remove();
                    setCookie('hide_header_banner', '2', HIDE_HEADER_BANNER_COOKIE_MINUTES); // remember there's no banner configured
                }
            }, BANNER_SLOT_LOAD_DEADLINE_MS);
        }
    }

    observeBannerContent();

    if (stripeBannerContainer && !bannerHidden) {
        removeClass(stripeBanner, CLASSES.hidden);

        function stopAutoplay(final = false) {
            const headerSwiperInstance = headerSwiper?.swiper;

            if (headerSwiperInstance) {
                try {
                    headerSwiperInstance.autoplay?.stop?.();

                    if (final) {
                        headerSwiperInstance.destroy(true, true); // deleteInstance + cleanupStyles
                    }
                } catch (err) {
                    // ignore
                }
            }
        }

        function startAutoplay() {
            const headerSwiperInstance = headerSwiper?.swiper;

            if (headerSwiperInstance) {
                try {
                    headerSwiperInstance.autoplay?.start?.();
                } catch (err) {
                    // ignore
                }
            }
        }

        function handlePauseBtn(e) {
            const isClick = e.type === 'click';
            const isKey = isActivation(e);
            if (!isClick && !isKey) return;

            e.preventDefault();
            e.stopPropagation();

            addClass(stripePauseBtn, CLASSES.hidden);
            removeClass(stripeArrowBtn, CLASSES.hidden);

            stopAutoplay();
            bannerManuallyPaused = true;

            setTimeout(() => {
                announceMessage('Promotion banner is paused');
            }, 50);
        }

        stripePauseBtn?.addEventListener('click', handlePauseBtn);
        stripePauseBtn?.addEventListener('keydown', handlePauseBtn);

        // a11y:
        stripeBannerContainer.addEventListener('focusin', (e) => {
            const target = e.target;
            if (!(target instanceof HTMLElement)) return;

            // Only when focus is within a slide
            const inSlide = target.closest('.rendering-template');
            if (!inSlide) return;

            stopAutoplay();
        });

        stripeBannerContainer.addEventListener('focusout', (e) => {
            if (bannerManuallyPaused) return;

            const nextFocus = e.relatedTarget;

            // If focus stays inside banner, do nothing
            if (nextFocus && stripeBannerContainer.contains(nextFocus)) return;

            startAutoplay();
        });

        function closeStripeBanner(e) {
            const isClick = !e || e.type === 'click';
            const isKey =
                e?.type === 'keydown' &&
                (e.key === EVENT_KEY_SPACE ||
                    e.key === EVENT_KEY_ENTER ||
                    e.keyCode === KEYCODE_SPACE ||
                    e.keyCode === KEYCODE_ENTER);
            if (!isClick && !isKey) return;

            e.preventDefault();
            e.stopPropagation();

            stopAutoplay(true);

            topNav.style.setProperty('--top-padding', '0'); // animate page up

            // ensure one source of truth for js and isml:
            setCookie('hide_header_banner', '1', HIDE_HEADER_BANNER_COOKIE_MINUTES);

            setTimeout(() => {
                stripeBannerContainer.remove(); // hide completely
                announceMessage('Promotion banner is closed.');
            }, ANIM_TIME_QUICK_2);
        }

        $(SELECTORS.bannerWrapperLinks).addClass('dropdown-item');

        stripeCloseBtn?.addEventListener('click', closeStripeBanner);
        stripeCloseBtn?.addEventListener('keydown', closeStripeBanner);
    }

    // =========================================================================
    // Main navigation (ARIA + keyboard + mouse + mobile)
    // =========================================================================
    // announce once keys for L1 nav DESKTOP:
    $categoryMenubar.on('focusin', function (e) {
        const el = e.target.closest(TOP_LINK_SEL);
        const idx = el ? $topLinks.index(el) : -1;
        if (idx >= 0) setActiveTop(idx);

        if (!announcedHelpTips && MEDIA.desktop.matches) {
            setTimeout(() => {
                announceMessage('Catalog. Left, right move between top items. Down opens submenu and moves to its first item. Up, down move inside. Enter activates, Escape closes submenu.');
            }, 50);

            announcedHelpTips = true;
        }
    });

    // Arm the lock and auto-unlock on first real pointer usage
    function armKbdHoverLock() {
        kbdHoverLock = true;
        // Unlock on first pointer/mouse/touch action
        $document
            .off('.kbdunlock')
            .one('pointermove.kbdunlock mousedown.kbdunlock touchstart.kbdunlock', () => {
                kbdHoverLock = false;
        });
    }

    function clamp(n, min, max) {
        return Math.max(min, Math.min(max, n));
    }

    function setActiveTop(index) {
        if (!$topLinks.length) return $();
        const i = clamp(index, 0, $topLinks.length - 1);
        $topLinks.attr('tabindex', '-1').removeClass(CLASSES.active);
        const $t = $topLinks.eq(i);
        $t.attr('tabindex', '0').addClass(CLASSES.active);
        try {
            sessionStorage.setItem(STORAGE_KEY, String(i));
        } catch (e) {}
        return $t;
    }

    // Ensure exactly one focusable top link
    (function initRoving() {
        if (!$topLinks.length) return;
        let start = 0;
        try {
            const saved = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
            if (!Number.isNaN(saved)) start = clamp(saved, 0, $topLinks.length - 1);
        } catch (e) {}
        if (!$topLinks.filter('[tabindex="0"]').length) {
            setActiveTop(start);
        } else {
            const $cur = $topLinks.filter('[tabindex="0"]').first();
            $topLinks.not($cur).attr('tabindex', '-1').removeClass(CLASSES.active);
            $cur.addClass(CLASSES.active);
        }
    })();

    function getMobileL1Links() {
        return $mainMenu.find(`${SELECTORS.categoryMenubar}  ${SELECTORS.navLink}, ${SELECTORS.mobileAccountMenubar} ${SELECTORS.navLink}`);
    }

    function closeAll(opts = {}) {
        const { silent = false } = opts;
        const wasOpen = submenuOpen;

        $mainNav.find(SELECTORS.dropdownMenu).attr('aria-hidden', 'true').removeClass(CLASSES.show);
        $(`${SELECTORS.navbarNav} .nav-item`).removeClass(CLASSES.show);
        $topItems.children('[role="menuitem"][aria-haspopup="menu"]').attr('aria-expanded', 'false');

        modal(false);
        $(SELECTORS.pageTopNav).removeClass(MENU_OPENED);
        $document.off('keydown.desktopNavEsc');

        if (wasOpen && !silent) announceMessage('Submenu closed');
        submenuOpen = false;

        // Only clear the roving intent on explicit (non-silent) closes
        if (!silent) rovingCarryOpen = false;
    }

    function openMenu($li) {
        const $menu = $li.children(SELECTORS.dropdownMenu);
        if (!$menu.length) return;

        closeAll({ silent: true });

        $li.addClass(CLASSES.show);
        $menu
            .attr({'role':'menu','aria-orientation':'vertical','aria-hidden':'false'})
            .addClass(CLASSES.show);
        $(SELECTORS.pageTopNav).addClass(MENU_OPENED);

        $li.children('[role="menuitem"][aria-haspopup="menu"]').attr('aria-expanded','true');
        modal(true);
        submenuOpen = true;

        const label = ($li.children(SELECTORS.navLink).text() || '').trim();
        announceMessage((label ? label + ': ' : '') + 'submenu opened');

        const $items = $menu.find('[role="menuitem"]:visible');
        if ($items.length) {
            $items.attr('tabindex','-1');
            $items.first().attr('tabindex','0');
        }
    }

    function focusNextTop($currentTopLink, dir, { openSub = false } = {}) {
        // Always close any open submenus before moving focus
        closeAll({ silent: true });

        const idx = $topLinks.index($currentTopLink);
        if (idx === -1) return;

        let nextIdx = idx + dir;
        if (nextIdx < 0) nextIdx = $topLinks.length - 1;
        if (nextIdx >= $topLinks.length) nextIdx = 0;

        const $next = setActiveTop(nextIdx);
        $next.trigger('focus');

        // If we came from an open submenu, open the submenu on the next item
        if (openSub) {
            const $nextLi = $next.closest(SELECTORS.topItem);
            const $menu = $nextLi.children(SELECTORS.dropdownMenu);
            if ($menu.length) {
                openMenu($nextLi);
            } else {
                // No submenu on the next item -> keep everything closed
                // (defensive, previous closeAll already did this)
                closeAll({ silent: true });
            }
        }
    }

    function getMobileL2Items($menu) {
        // L3 links, nav-asset links, and L2 accordion titles (DOM order)
        let $items = $menu.find(
            `${SELECTORS.dropdownLinkVisible}, ${SELECTORS.navAssetLinkVisible}, ${SELECTORS.subCatName}:visible`
        );
        if (!$items.length) {
            $items = $menu.find('a:visible, button:visible').not(SELECTORS.backInTopCategory);
        }
        return $items;
    }

    /**
     * L2 titles are only accordion triggers on mobile/tablet. Desktop renders every panel
     * open and makes the title inert (pointer-events: none), so expanded/controls state
     * there would announce a control that cannot be operated.
     * @param {JQuery} [$scope] - subtree to sync, defaults to the whole nav
     */
    function syncL2AccordionAria($scope) {
        const $items = ($scope || $mainNav).find(SELECTORS.subMenuItem);
        if (!$items.length) return;

        const isDesktop = MEDIA.desktop.matches;

        $items.each(function () {
            const $item = $(this);
            const $trigger = $item.children(SELECTORS.subCatName);
            if (!$trigger.length) return;

            if (isDesktop) {
                $trigger.removeAttr('aria-expanded').removeAttr('aria-controls');
                return;
            }

            const panelId = $item.children(SELECTORS.subMenuItemPanel).attr('id');
            if (panelId) $trigger.attr('aria-controls', panelId);
            $trigger.attr('aria-expanded', $item.hasClass(SELECTORS.subMenuItemExpanded) ? 'true' : 'false');
        });
    }

    /**
     * Mobile L2 accordion: expand sections flagged in BM (custom.isExpanded), collapse the rest.
     * Called when opening an L1 submenu on mobile/tablet (resets to BM defaults each time).
     * @param {JQuery} $menu - L1 dropdown menu element
     */
    function initMobileL2Accordions($menu) {
        const $items = $menu.find(SELECTORS.subMenuItem);
        if (!$items.length) return;

        $items.each(function () {
            const $item = $(this);
            $item.toggleClass(SELECTORS.subMenuItemExpanded, $item.attr('data-default-expanded') === 'true');
        });

        syncL2AccordionAria($menu);
    }

    function isActivation(e) {
        return (
            e.type === 'click' ||
            (e.type === 'keydown' &&
                (e.key === EVENT_KEY_ENTER ||
                    e.key === EVENT_KEY_SPACE ||
                    e.keyCode === KEYCODE_ENTER ||
                    e.keyCode === KEYCODE_SPACE))
        );
    }

    function getFocusables($root) {
        return $root
            .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
            .filter(':visible');
    }

    function trapFocus($container) {
        $container.on('keydown.mobileTrap', function (e) {
            if (e.key !== EVENT_KEY_TAB) return;
            if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) return;

            // Mobile ring:
            if (MEDIA.mobile.matches) {
                const ring = getMobileNavRing();
                if (cycleRingFocus(e, ring)) return;
            }

            // Desktop fallback
            const $f = getFocusables($container);
            if (!$f.length) return;
            const first = $f[0];
            const last = $f[$f.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    }

    function releaseFocus($container) {
        $container.off('keydown.mobileTrap');
    }

    function openMobileMenu() {
        if (!restoreFocusEl) restoreFocusEl = document.activeElement;

        $mainMenu.addClass(CLASSES.in);
        $(SELECTORS.menuGroupNavItem).removeClass(CLASSES.show);
        $body.addClass(CLASSES.mobileOpen);

        // ARIA for modal drawer
        $mainMenu.attr({ 'aria-hidden': 'false', role: 'dialog', 'aria-modal': 'true' });
        $mainMenu.siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        const $toggler = $(SELECTORS.navbarToggler);
        if ($toggler.length) $toggler.trigger('focus');

        // sync toggler ARIA
        $(SELECTORS.navbarToggler).attr({ 'aria-expanded': 'true', 'aria-controls': $mainMenu.attr('id') || 'main-menu' });

        trapFocus($mainMenu);

        modal(true);
        isMobileOpen = true;

        if (!announcedHelpTips && MEDIA.mobile.matches) {
            setTimeout(() => {
                announceMessage('Catalog. Up, down move through the top items. Enter activates or opens submenu, Escape closes submenu.');
            }, 50);

            announcedHelpTips = true;
        }
    }

    function closeMobileMenu() {
        $mainMenu.removeClass(CLASSES.in);
        $mainMenu.attr('aria-hidden', 'true').removeAttr('role aria-modal');
        $mainMenu.siblings().attr('aria-hidden', 'false');
        $body.removeClass(CLASSES.mobileOpen);
        $('header').siblings().attr('aria-hidden', 'false');
        $(`${SELECTORS.navbarNav} .nav-item`).removeClass(CLASSES.show);
        releaseFocus($mainMenu);
        $document.off('keydown.mobileEsc');

        const $toggler = $(SELECTORS.navbarToggler);
        if ($toggler.length) {
            $toggler.attr('aria-expanded', 'false').trigger('focus');
        } else if (restoreFocusEl) {
            restoreFocusEl.focus();
        }
        restoreFocusEl = null;

        modal(false);
        isMobileOpen = false;
    }

    function getActiveNavElements(navItem) {
        return {
            activeDropDown: queryFirst(SELECTORS.dropdownContainer, navItem),
            activeNavLink: queryFirst(SELECTORS.navLink, navItem)
        };
    }

    function openNavItem(navItem) {
        const { activeDropDown, activeNavLink } = getActiveNavElements(navItem);
        const $li = $(navItem);

        if (activeDropDown && activeNavLink) {
            addClass([navItem, activeDropDown], CLASSES.show);
            $li.attr('aria-expanded', 'true');

            if (!activeDropDown.matches('.user-account-dropdown-menu, .store-locator-dropdown-menu')) {
                activeDropDown.setAttribute('aria-hidden', 'false');
            }

            if (MEDIA.desktop.matches) {
                $(SELECTORS.pageTopNav).addClass(MENU_OPENED);
            }

            modal(true);
        }
    }

    function closeNavItem(navItem) {
        const { activeDropDown, activeNavLink } = getActiveNavElements(navItem);
        const $li = $(navItem);

        if (activeDropDown && activeNavLink) {
            removeClass([navItem, activeDropDown], CLASSES.show);
            $li.attr('aria-expanded', 'false');

            if (!activeDropDown.matches('.user-account-dropdown-menu, .store-locator-dropdown-menu')) {
                activeDropDown.setAttribute('aria-hidden', 'true');
                $(activeDropDown).find('a').attr('tabindex', '-1');
            }

            if (MEDIA.mobile.matches) {
                $('.navbar-nav .nav-item > a').attr('aria-hidden', 'false');
            }

            removeClass(queryFirst(SELECTORS.pageTopNav), MENU_OPENED);
            modal(false);
        }
    }

    function toggleSubmenu() {
        if (isNavActive) openNavItem(activeNavItem);
        else closeNavItem(activeNavItem);
    }

    function hideOtherMenus(eventElement) {
        $('.nav-item').each((i, e) => {
            if (!$.contains(e, eventElement)) {
                if (hasClass(e, CLASSES.show)) {
                    closeNavItem(e);
                }
            }
        });
    }

    // Active L1 link: same as desktop (tabindex="0" or first) for Tab ring
    function getMobileActiveL1Link() {
        if (!$topLinks.length) return null;
        const $cur = $topLinks.filter('[tabindex="0"]').first();
        return ($cur.length ? $cur : $topLinks.first()).get(0);
    }

    // Active L2 item in open submenu: tabindex="0" or first, same style as desktop.
    // Use .nav-item.show (same as Back) so we get the correct menu when L2 has multiple sub-sections.
    function getMobileActiveL2Item() {
        const $showLi = $mainMenu.find('.nav-item.show').first();
        if (!$showLi.length) return null;
        const $menu = $showLi.children(SELECTORS.dropdownMenu).first();
        if (!$menu.length) return null;
        const $items = getMobileL2Items($menu);
        if (!$items.length) return null;
        const $cur = $items.filter('[tabindex="0"]').first();
        return ($cur.length ? $cur : $items.first()).get(0);
    }

    function getMobileNavRing() {
        const togglerEl = queryFirst(SELECTORS.navbarToggler);
        const logoEl = queryFirst(SELECTORS.headerNavLogoLink);
        const backEl = queryFirst('.nav-item.show .top-category .back');
        const backButton = isVisible(backEl) ? backEl : null;

        const ring = [];
        if (backButton) {
            ring.push(backButton);
            if (togglerEl) ring.push(togglerEl);
            const activeL2 = getMobileActiveL2Item();
            if (activeL2) ring.push(activeL2);
        } else {
            if (logoEl) ring.push(logoEl);
            if (togglerEl) ring.push(togglerEl);
            const activeL1 = getMobileActiveL1Link();
            if (activeL1) ring.push(activeL1);
        }
        return ring.filter(Boolean);
    }

    function cycleRingFocus(e, ring) {
        if (!ring.length) return false;

        const active = document.activeElement;
        let idx = ring.indexOf(active);
        if (idx === -1) idx = e.shiftKey ? ring.length : -1;

        const next = e.shiftKey
            ? (idx <= 0 ? ring.length - 1 : idx - 1)
            : (idx >= ring.length - 1 ? 0 : idx + 1);

        e.preventDefault();
        ring[next]?.focus();
        return true;
    }

    // Accessibility attribute switch based on breakpoint:
    function applyL1Orientation() {
        const el = $categoryMenubar.get(0);
        if (!el) return;
        el.setAttribute('role', 'menu');
        el.setAttribute('aria-orientation', MEDIA.desktop.matches ? 'horizontal' : 'vertical');
    }

    applyL1Orientation();
    syncL2AccordionAria();

    function openMyAccountOnHover(e) {
        if (!MEDIA.desktop.matches || !myAccountHoverSheet) return;

        if (hasClass(myAccountHoverSheet, CLASSES.show) || myAccountHoverSheet.getAttribute('aria-hidden') === 'false') {
            return;
        }

        closeAll({ silent: true });

        $(myAccountHoverSheet).modal('show');

        isNavActive = false;
    }

    function syncMyAccountTarget() {
        if (!myAccountLink) return;

        const li = myAccountLink.closest(SELECTORS.topItem);
        const isLoggedIn = li && hasClass(li, SELECTORS.activeAccountClass);

        if (!isLoggedIn && !MEDIA.mobile.matches) {
            myAccountLink.removeAttribute('data-toggle');
            myAccountLink.removeAttribute('data-target');
            return;
        }

        // Logged-in:
        myAccountLink.setAttribute('data-toggle', 'modal');
        myAccountLink.setAttribute('data-target', MEDIA.mobile.matches ? MYACCOUNT_MOBILE_TARGET : MYACCOUNT_POSTLOGIN_DESKTOP_TARGET);
    }

    syncMyAccountTarget();

    // ------------------------  Mobile keyboard nav -----------------------
    // Mobile: unified handler for L1 links and trap entry
    // - Enter/Space on L1 with submenu → open submenu
    // - Up/Down/Home/End on L1 → vertical navigation across L1 items
    $mainNav
    .off('keydown.mobileL1Unified')
    .on('keydown.mobileL1Unified', `${SELECTORS.navbarToggler}, ${SELECTORS.headerNavLogoLink}, ${TOP_LINK_SEL}`, function (e) {
        if (!MEDIA.mobile.matches) return;

        // trap logo and toggler:
        const key = e.key;
        const drawerOpen = $body.hasClass(CLASSES.mobileOpen);
        const isTrapEl = this.matches(`${SELECTORS.navbarToggler}, ${SELECTORS.headerNavLogoLink}`);

        // Arrows/Home/End from logo or toggler do nothing — list nav only when focus is already in list
        if (isTrapEl && (key === EVENT_KEY_DOWN || key === EVENT_KEY_UP || key === EVENT_KEY_HOME || key === EVENT_KEY_END)) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        // else - on L1:
        const $link = $(this);
        const $li   = $link.closest(SELECTORS.topItem);
        const $menu = $li.children(SELECTORS.dropdownMenu);
        const hasSub = $menu.length > 0;

        if (!isTrapEl && key === EVENT_KEY_SPACE) {
            e.preventDefault();
            e.stopPropagation();

            if (hasSub) { // categories L1
                $link.trigger('click');
            } else { // mobile utility nav
                $link[0].click();
            }

            return;
        }

        if (key === EVENT_KEY_DOWN || key === EVENT_KEY_UP || key === EVENT_KEY_HOME || key === EVENT_KEY_END) {
            e.preventDefault();
            e.stopPropagation();

            if (!drawerOpen) return;

            const $links = getMobileL1Links();

            if (!$links.length) return;

            const idx = $links.index(this);
            const dir = (key === EVENT_KEY_DOWN) ? 1 : -1;
            const nextIdx = (idx + dir + $links.length) % $links.length;
            $links.eq(nextIdx).focus();
        }
    });

    // Mobile: Arrow/Home/End/Space  L2
    $mainNav
    .off('keydown.mobileL2Nav')
    .on('keydown.mobileL2Nav', `${SELECTORS.dropdownMenu} a, ${SELECTORS.dropdownMenu} button`, function (e) {
        if (!MEDIA.mobile.matches) return;
        const key   = e.key;
        const $menu = $(this).closest(SELECTORS.dropdownMenu);
        const $items = getMobileL2Items($menu);
        if (!$items.length) return;

        const i = $items.index(this);
        const isBack = $(this).is(SELECTORS.backInTopCategory);

        // Arrows/Home/End only when focus is in list; from Back do nothing
        if (isBack && (key === EVENT_KEY_DOWN || key === EVENT_KEY_UP || key === EVENT_KEY_HOME || key === EVENT_KEY_END)) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        if (key === EVENT_KEY_DOWN) {
            e.preventDefault();
            e.stopPropagation();
            const $target = $items.eq((i + 1) % $items.length);
            $items.attr('tabindex', '-1');
            $target.attr('tabindex', '0').focus();
            return;
        }
        if (key === EVENT_KEY_UP) {
            e.preventDefault();
            e.stopPropagation();
            const $target = $items.eq((i - 1 + $items.length) % $items.length);
            $items.attr('tabindex', '-1');
            $target.attr('tabindex', '0').focus();
            return;
        }
        if (key === EVENT_KEY_HOME) {
            e.preventDefault();
            e.stopPropagation();
            $items.attr('tabindex', '-1');
            $items.first().attr('tabindex', '0').focus();
            return;
        }
        if (key === EVENT_KEY_END) {
            e.preventDefault();
            e.stopPropagation();
            $items.attr('tabindex', '-1');
            $items.last().attr('tabindex', '0').focus();
            return;
        }
        if (key === EVENT_KEY_SPACE) {
            e.preventDefault();
            e.stopPropagation();
            this.click();
            return;
        }
    });

    // Mobile: L1 -> L2 submenu on tap/click
    $categoryMenubar
    .off('click.mobileTopOpen')
    .on('click.mobileTopOpen', TOP_LINK_SEL, function (e) {
        if (MEDIA.desktop.matches) return;

        const $link = $(this);
        const $li = $link.closest(SELECTORS.topItem);
        const $menu = $li.children(SELECTORS.dropdownMenu);

        if (!$menu.length) return; // follow default navigation if no submenu

        e.preventDefault();

        const $grid = $menu.children('.sub-menu-grid');
        if (!$grid.length) return;
        modal(true);

        initMobileL2Accordions($menu);

        // One focusable item in list (active): same as desktop — first has tabindex="0"
        const $listItems = $menu.find('a, button').not(SELECTORS.backInTopCategory);
        $listItems.attr('tabindex', '-1');
        if ($listItems.length) $listItems.first().attr('tabindex', '0');

        // Open mobile drawer state for this item
        $li.addClass(CLASSES.show).attr('aria-expanded', 'true');
        $menu.attr('aria-hidden', 'false').removeClass(CLASSES.show);
        $mainMenu.addClass(CLASSES.in).attr('aria-hidden', 'false');
        $body.addClass(CLASSES.mobileOpen);

        // Move focus to Back
        setTimeout(() => {
            $grid.find(SELECTORS.backInTopCategory).first().trigger('focus');
        }, 0);
    });

    // Mobile: L2 category accordion toggle
    $mainNav
    .off('click.mobileL2Accordion')
    .on('click.mobileL2Accordion', SELECTORS.subCatName, function (e) {
        if (!MEDIA.mobile.matches) return;
        if (!isActivation(e)) return;

        e.preventDefault();
        e.stopPropagation();

        const $trigger = $(this);
        const $item = $trigger.closest(SELECTORS.subMenuItemClosest);
        if (!$item.length) return;

        const willExpand = !$item.hasClass(SELECTORS.subMenuItemExpanded);
        $item.toggleClass(SELECTORS.subMenuItemExpanded, willExpand);
        $trigger.attr('aria-expanded', willExpand ? 'true' : 'false');
    });

    // ------------------------  Desktop keyboard nav -----------------------
    // Desktop: keyboard on L1
    $categoryMenubar
    .off('keydown.desktopTopNav')
    .on('keydown.desktopTopNav', TOP_LINK_SEL, function (e) {
        if (!MEDIA.desktop.matches) return;

        const key   = e.key;
        const $link = $(this);
        const $li   = $link.closest(SELECTORS.topItem);
        const $menu = $li.children(SELECTORS.dropdownMenu);
        const hasSub = $menu.length > 0;

        // Prevent page scroll when no submenu and user presses Up/Down
        if ((key === EVENT_KEY_DOWN || key === EVENT_KEY_UP) && !hasSub) {
            e.preventDefault();
            e.stopPropagation();
            announceMessage('No submenu. Use left/right to move.');
            return;
        }

        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        switch (key) {
            case EVENT_KEY_ESC: {
                e.preventDefault();
                if ($li.hasClass(CLASSES.show) || submenuOpen) {
                    closeAll();
                    if ($link.attr('tabindex') === '-1') $link.attr('tabindex','0');
                    setTimeout(() => $link.trigger('focus'), 0);
                }
                return;
            }
            case EVENT_KEY_LEFT: {
                e.preventDefault();
                const startedOpen = $li.hasClass(CLASSES.show) || submenuOpen || rovingCarryOpen;
                rovingCarryOpen = startedOpen;
                armKbdHoverLock();
                focusNextTop($link, -1, { openSub: rovingCarryOpen });
                return;
            }
            case EVENT_KEY_RIGHT: {
                e.preventDefault();
                const startedOpen = $li.hasClass(CLASSES.show) || submenuOpen || rovingCarryOpen;
                rovingCarryOpen = startedOpen;
                armKbdHoverLock();
                focusNextTop($link, +1, { openSub: rovingCarryOpen });
                return;
            }
            case EVENT_KEY_HOME:
                e.preventDefault();
                setActiveTop(0).focus();
                return;
            case EVENT_KEY_END:
                e.preventDefault();
                setActiveTop($topLinks.length - 1).focus();
                return;
            case EVENT_KEY_DOWN:
                if (!hasSub) return;
                e.preventDefault();
                armKbdHoverLock();
                if (!$li.hasClass(CLASSES.show)) openMenu($li);
                const $first = $menu.find('[role="menuitem"]:visible').first();
                if ($first.length) $first.focus();
                return;
            case EVENT_KEY_UP:
                if (!hasSub) return;
                e.preventDefault();
                armKbdHoverLock();
                if (!$li.hasClass(CLASSES.show)) openMenu($li);
                const $last = $menu.find('[role="menuitem"]:visible').last();
                if ($last.length) $last.focus();
                return;
            case EVENT_KEY_TAB:
                if (e.shiftKey || !submenuOpen) return;
                const $icons = $headerIconsMenubar.find(`${SELECTORS.topItem} > ${SELECTORS.navLink}`);
                e.preventDefault();
                e.stopPropagation();
                closeAll({ silent: true });
                $icons.first().trigger('focus');
                return;
            case EVENT_KEY_SPACE:
                if ($li.children('[role="menuitem"][aria-haspopup="menu"]').is(this)) {
                    if (!$li.hasClass(CLASSES.show)) openMenu($li);
                    const $first = $li.children(SELECTORS.dropdownMenu).find('[role="menuitem"]:visible').first();
                    if ($first.length) $first.focus();
                } else {
                    this.click();
                }
                return;
            case EVENT_KEY_ENTER:
            default:
                return;
        }
    });

    // Desktop: L2 Submenu keys: Up/Down, Esc, Tab
    $categoryMenubar.on('keydown', SELECTORS.subKeyTargets, function (e) {
        if (MEDIA.mobile.matches) return;
        const key = e.key;
        const $current = $(this);

        // If this submenu is inside the icon nav, handle it in the icon handler
        if ($current.closest(SELECTORS.headerIconsGroup).length) return;

        const $menu = $current.closest(SELECTORS.dropdownMenu);
        let $items = $menu.find('[role="menuitem"]:visible');
        if (!$items.length) return;

        const idx = $items.index($current);
        const lastIdx = $items.length - 1;

        if (key === EVENT_KEY_TAB && e.shiftKey) {
            if (!submenuOpen) return;

            e.preventDefault();
            e.stopPropagation();

            closeAll({ silent: true });

            const $logo = $(SELECTORS.headerNavLogoLink);

            $logo[0].focus();

            return;
        }

        if (key === EVENT_KEY_DOWN) {
            e.preventDefault();
            const next = idx >= 0 ? (idx + 1) % $items.length : 0;
            $items.attr('tabindex','-1');
            $items.eq(next).attr('tabindex','0').focus();
            return;
        }

        if (key === EVENT_KEY_UP) {
            e.preventDefault();
            const prev = idx >= 0 ? (idx - 1 + $items.length) % $items.length : lastIdx;
            $items.attr('tabindex','-1');
            $items.eq(prev).attr('tabindex','0').focus();
            return;
        }

        // Home/End: jump to first/last item in submenu
        if (key === EVENT_KEY_HOME) {
            e.preventDefault();
            $items.attr('tabindex','-1');
            $items.first().attr('tabindex','0').focus();
            return;
        }

        if (key === EVENT_KEY_END) {
            e.preventDefault();
            $items.attr('tabindex','-1');
            $items.last().attr('tabindex','0').focus();
            return;
        }

        if (key === EVENT_KEY_LEFT || key === EVENT_KEY_RIGHT) {
            e.preventDefault();
            e.stopPropagation();

            const $trigger = $menu.closest(SELECTORS.topItem).children('[role="menuitem"]').first();

            // We are roving from an open submenu → keep intent alive and suppress hover
            rovingCarryOpen = true;
            armKbdHoverLock();             // <-- lock hover now

            if ($trigger.length) {
                focusNextTop($trigger, key === EVENT_KEY_LEFT ? -1 : 1, { openSub: true });
            }
            return;
        }

        if (key === EVENT_KEY_ESC) {
            e.preventDefault();
            const $trigger = $menu
                .closest(SELECTORS.topItem)
                .children('[role="menuitem"], ' + SELECTORS.navLink)
                .first();

            closeAll();

            setTimeout(() => {
                if ($trigger.length) {
                    if ($trigger.attr('tabindex') === '-1') $trigger.attr('tabindex', '0');
                    $trigger.trigger('focus');
                }
            }, 0);
            return;
        }
    });

    // Desktop: If focus leaves category nav (and not into submenu), close all
    $categoryMenubar.on('focusout', function (e) {
        if (MEDIA.mobile.matches) return;

        const to = e.relatedTarget;

        if (!to) { closeAll(); return; }

        const $to = $(to);

        const inMainNav   = $to.closest(SELECTORS.mainNav).length > 0;
        const inAnySub    = $to.closest(SELECTORS.dropdownMenu).length > 0;
        const inCategory  = $to.closest(SELECTORS.categoryMenubar).length > 0;

        if (!inMainNav || (!inAnySub && !inCategory)) {
            closeAll();
        }
    });

    // Click outside closes everything
    $document.on('mousedown touchstart', function (e) {
        if ($body.hasClass('filters-open')) return;

        if (!$(e.target).closest(SELECTORS.mainNav).length) {
            closeAll();
        }
    });

    // Global mobile Tab ring: Tab between three elements — logo, toggler, active L1 link; or back, toggler, active L2 item
    document.addEventListener('keydown', function mobileGlobalRing(e) {
        if (e.key !== EVENT_KEY_TAB || !MEDIA.mobile.matches || !isMobileOpen) return;

        const ring = getMobileNavRing();
        if (!ring.length) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        cycleRingFocus(e, ring);
    }, true);

    // Close mobile nav by clicking on the backdrop
    $modalBG.on('click', () => {
        if ($body.hasClass(CLASSES.mobileOpen)) {
            closeMobileMenu();
        }
    });

    // ------------------------ Desktop hover handlers ------------------------
    $mainNav.on('mouseenter', `${SELECTORS.navbarNav} > ${SELECTORS.topItem}`, function (e) {
        if (!MEDIA.desktop.matches || kbdHoverLock) return; // <-- ignore hover while keyboard is in control
        hoverIntentTimer = setTimeout(() => {
            clearTimeout(closeNavTimer);
            hoverIntentTimer = null;
            isNavActive = true;

            activeNavItem = this;
            $mainNav.trigger('navdropdown:show', e);
            hideOtherMenus(this);
            toggleSubmenu();
        }, isNavActive ? 0 : hoverIntentDelay);
    });

    $mainNav.on('mouseleave', `${SELECTORS.navbarNav} > ${SELECTORS.topItem}`, function (e) {
        if (!MEDIA.desktop.matches || kbdHoverLock) return; // <-- ignore while locked

        if (hoverIntentTimer) {
            clearTimeout(hoverIntentTimer);
        } else {
            closeNavTimer = setTimeout(() => {
                isNavActive = false;
                $mainNav.trigger('navdropdown:hide', e);
                toggleSubmenu();
            }, closeNavDelay);
        }
    });

    // Keep open when pointer re-enters an active dropdown
    $mainNav.on('mouseenter', SELECTORS.dropdownContainer, (e) => {
        if (kbdHoverLock) return; // <-- ignore while locked
        if (hasClass(e.currentTarget, CLASSES.show)) {
            clearTimeout(closeNavTimer);
        }
    });

    // ------------------------ Mobile click  ---------------------------------
    // Back inside the menu
    $(SELECTORS.navbarNav).on('click', '.back', function (e) {
        if (!isActivation(e)) return;
        e.preventDefault();
        const navItem = e.currentTarget.closest('.nav-item');
        closeNavItem(navItem);
        setTimeout(() => {
            const $parentTrigger = $(navItem).children(`${SELECTORS.navLink}, .nav-toggle`).first();
            if ($parentTrigger.length) $parentTrigger.trigger('focus');
            else $(SELECTORS.navbarToggler).trigger('focus');
        }, 0);
    });

    // Hamburger toggler
    $(SELECTORS.navbarToggler).on('click', function (e) {
        if (!isActivation(e)) return;
        e.preventDefault();

        if ($(SELECTORS.stripeBanner).is(':visible')) {
            $mainNav.addClass(CLASSES.hasBanner);
        } else {
            $mainNav.removeClass(CLASSES.hasBanner);
        }

        if ($(SELECTORS.evgHeroBanner).is(':visible')) {
            $mainNav.addClass(CLASSES.hasSkinnyBanner);
        } else {
            $mainNav.removeClass(CLASSES.hasSkinnyBanner);
        }

        isMobileOpen ? closeMobileMenu() : openMobileMenu();
    });

    // --------------------------- Header icon menus --------------------------
    // Desktop: Keyboard on triggers (icon nav)
    $headerIconsMenubar.on('keydown', TOP_LINK_SEL, function (e) {
        if(MEDIA.mobile.matches) return;
        const key   = e.key;
        const $link = $(this);
        const $li   = $link.closest('li.nav-item');
        const $menu = $li.children(SELECTORS.dropdownMenu);
        const hasSub = $menu.length > 0;

        // Up/Down: open submenu, prevent page scroll when no submenu
        if (key === EVENT_KEY_DOWN || key === EVENT_KEY_UP) {
            if (!hasSub) {
                e.preventDefault();
                e.stopPropagation();
                announceMessage('No submenu. Use tab to move.');
                return;
            }

            e.preventDefault();
            if (!$li.hasClass(CLASSES.show)) openNavItem($li[0]);
            const $items = $menu.find(SELECTORS.dropdownLinkVisible);
            if ($items.length) (key === EVENT_KEY_DOWN ? $items.first() : $items.last()).focus();
            return;
        }

        // Enter/Space: if pure link - open url, else open submenu
        if (key === EVENT_KEY_ENTER || key === EVENT_KEY_SPACE) {
            e.preventDefault();
            const isOpen = $li.hasClass(CLASSES.show);
            // Always close Catalog L1/L2 before interacting with header icon menus (avoid 2 menus open)
            closeAll({ silent: true });
            if (isOpen) {
                closeNavItem($li[0]);
                $link.focus();
            } else if (hasSub) {
                openNavItem($li[0]);
                setTimeout(() => {
                    const $items = $menu.find(SELECTORS.dropdownLinkVisible);
                    if ($items.length) $items.first().focus();
                }, 0);
            } else {
                // Plain link → follow default navigation on Enter/Space
                $link[0].click();
            }
            return;
        }
    });

    // All breakpoints: Keys inside icon submenus
    $headerIconsMenubar.on('keydown', SELECTORS.subKeyTargets, function (e) {
        const key = e.key;
        const $curr = $(this);
        const $menu = $curr.closest(SELECTORS.dropdownMenu);
        const $li = $menu.closest(SELECTORS.topItem);
        const $trigger = $li.children(SELECTORS.navLink).first();

        // Arrow navigation inside the submenu
        if (key === EVENT_KEY_DOWN || key === EVENT_KEY_UP) {
            e.preventDefault();
            let $items = $menu.find(SELECTORS.dropdownLinkVisible);
            if (!$items.length) $items = $menu.find('a:visible').not('.back, .close-button');
            if (!$items.length) return;
            const i = $items.index($curr);
            const next = key === EVENT_KEY_DOWN ? (i + 1) % $items.length : (i - 1 + $items.length) % $items.length;
            $items.eq(next).focus();
            return;
        }

        // Home/End: jump to first/last item in icon submenu
        if (key === EVENT_KEY_HOME || key === EVENT_KEY_END) {
            e.preventDefault();
            let $items = $menu.find(SELECTORS.dropdownLinkVisible);
            if (!$items.length) $items = $menu.find('a:visible').not('.back, .close-button');
            if ($items.length) (key === EVENT_KEY_HOME ? $items.first() : $items.last()).focus();
            return;
        }

        // Esc: close and return focus to the trigger
        if (key === EVENT_KEY_ESC) {
           e.preventDefault();
            closeNavItem($li[0]);
            $trigger.focus();
            return;
        }

        if (key === EVENT_KEY_ENTER || key === EVENT_KEY_SPACE) {
            modal(false);
            closeNavItem($li[0]);
            return;
        }

        // Desktop only: Tab / Shift+Tab: move to prev/next icon trigger
        if (MEDIA.desktop.matches && key === EVENT_KEY_TAB) {
            const $icons = $headerIconsMenubar.find(`${SELECTORS.topItem} > ${SELECTORS.navLink}`);
            const idx = $icons.index($trigger);

            if (e.shiftKey) {
                if (idx > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    closeNavItem($li[0]);
                    $icons.eq(idx - 1).trigger('focus');
                } else {
                    closeNavItem($li[0]);
                }
            } else {
                closeNavItem($li[0]);
            }

            return;
        }
    });

    // Fallback for screen reader:
    document.addEventListener('keyup', function (e) {
        if (e.key !== EVENT_KEY_ESC) return;
        const inNav = !!(e.target && $(e.target).closest(SELECTORS.mainNav).length);
        if (!inNav) return;

        if (submenuOpen) {
            e.preventDefault();
            const $menu = $(e.target).closest(SELECTORS.dropdownMenu);
            const $trigger = $menu
                .closest(SELECTORS.topItem)
                .children('[role="menuitem"], ' + SELECTORS.navLink)
                .first();

            closeAll();

            setTimeout(() => {
                if ($trigger.length) {
                    if ($trigger.attr('tabindex') === '-1') $trigger.attr('tabindex','0');
                    $trigger.trigger('focus');
                }
            }, 0);
        }
    }, false);

    (function attachGlobalEscHandler() {
        const handler = function (e) {
            if (e.key !== EVENT_KEY_ESC) return;
            if ($body.hasClass('filters-open')) return;

            const inNav = !!(e.target && $(e.target).closest(SELECTORS.mainNav).length);

            // Desktop nav handles ESC itself (keeps focus on L1 correctly)
            if (MEDIA.desktop.matches && inNav) {
                return;
            }

            if (MEDIA.mobile.matches && isMobileOpen) {
                closeMobileMenu?.();
                closeAll?.();
                return;
            }

            // Outside of desktop nav: safe fallback
            closeAll?.();
        };

        document.addEventListener('keydown', handler, true);
    })();

    // --------------------------- Breakpoint switch ---------------------------
    // Leading-edge resize throttle was dropping the event that crossed 1200px,
    // leaving .mobile-menu-open and .modal-background stuck. matchMedia 'change'
    // fires exactly once when the breakpoint flips (resize + orientation).
    let prevBreakpointIsDesktop = MEDIA.desktop.matches;

    function resetMobileNavForDesktop() {
        if (isMobileOpen || $body.hasClass(CLASSES.mobileOpen)) {
            closeMobileMenu();
        } else {
            $mainMenu.removeClass(CLASSES.in).attr('aria-hidden', 'true');
            $body.removeClass(CLASSES.mobileOpen);
            $(`${SELECTORS.navbarNav} .nav-item`).removeClass(CLASSES.show);
            releaseFocus($mainMenu);
            modal(false);
            isMobileOpen = false;
            $(SELECTORS.navbarToggler).attr('aria-expanded', 'false');
        }
        closeAll({ silent: true });
    }

    function onDesktopBreakpointChange() {
        const isDesktop = MEDIA.desktop.matches;

        if (!prevBreakpointIsDesktop && isDesktop) {
            resetMobileNavForDesktop();
        }

        prevBreakpointIsDesktop = isDesktop;
        applyL1Orientation();
        syncL2AccordionAria();
        syncMyAccountTarget();
    }

    if (typeof MEDIA.desktop.addEventListener === 'function') {
        MEDIA.desktop.addEventListener('change', onDesktopBreakpointChange);
    } else if (typeof MEDIA.desktop.addListener === 'function') {
        MEDIA.desktop.addListener(onDesktopBreakpointChange);
    }

    // ----------------------- Modal padding (scrollbar fix) -------------------
    function toggleNoScrollPadding(shouldAdd) {
        if(shouldAdd) {
            document.body.style.paddingRight = scrollBarWidth;
        } else {
            document.body.style.removeProperty('padding-right');
        }
    }

    function modalPaddingObserver() {
        const observerConfig = {
            attributes: true,
            childList: false,
            subtree: false,
            characterData: false,
            attributeFilter: ['class'],
            attributeOldValue: true
        };

        const toggleClasses = ['modal-open', 'no-scroll'];

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    let classRemoved = false;
                    let classAdded = false;
                    let classStillExists = false;

                    const needsToggle = toggleClasses.reduce((prev, targetClass) => {
                        const classCurrentlyExists = hasClass(mutation.target, targetClass);
                        const classUsedToExist = mutation.oldValue && mutation.oldValue.includes(targetClass);
                        classRemoved = classRemoved || (classUsedToExist && !classCurrentlyExists);
                        classAdded = classAdded || (!classUsedToExist && classCurrentlyExists);
                        classStillExists = classStillExists || (!classRemoved && !classAdded && classCurrentlyExists);
                        return prev || classRemoved || classAdded;
                    }, false);

                    if (needsToggle && !classStillExists) {
                        toggleNoScrollPadding(classAdded);
                    }
                }
            });
        });

        observer.observe(bodyEl, observerConfig);
    }

    modalPaddingObserver();
};
